import {useListingFilters} from "@/utils/listing-utils.ts";

interface PaginationProps {
  /** 1-based page number we are currently viewing. */
  currentPage: number
  /** Cursor for the next page, or null/undefined when there is no next page. */
  nextCursor?: string | null
  /** Cursor for the previous page, or null/undefined when on the first page. */
  prevCursor?: string | null
}

/**
 * Pagination Component (cursor-based)
 *
 * Confluence's search API uses opaque cursors rather than page offsets, so we
 * can only move to the adjacent (prev / next) page. The page number is kept for
 * display and for the browser history entry; the cursors come from the API
 * response.
 */

export default function Pagination({
  currentPage,
  nextCursor,
  prevCursor,
}: PaginationProps) {
  const hasPrev = currentPage > 1 && Boolean(prevCursor)
  const hasNext = Boolean(nextCursor)


  // Nothing to paginate.
  if (!hasPrev && !hasNext) {
    return null
  }

  const { goToPage } = useListingFilters();

  return (
    <nav aria-label="Policy Library Pagination" className="policy-library-listing-pagination">
      <ul className="pagination">
          {prevCursor && (
        <li key="prev-btn">
          <button
            className="prev Button Button-styled Button--red"
            onClick={() => goToPage(currentPage - 1, prevCursor ?? undefined, 'prev')}
            aria-label="Previous page"
            disabled={!hasPrev}>
            <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="19"><path d="m8.889 8.527-5.171 8.528A15.567 15.567 0 0 1 0 15.333l4.128-6.806L0 1.722A15.735 15.735 0 0 1 3.718 0l5.17 8.527Z"></path></svg></span>
          </button>
        </li>
              )}
        <li key="current-page">
          <span className="page-numbers currentpage" aria-current="page">
            Page {currentPage}
          </span>
        </li>
          {nextCursor && (
        <li key="next-btn">
          <button
            className="next Button Button-styled Button--red"
            onClick={() => goToPage(currentPage + 1, nextCursor ?? undefined, 'next')}
            aria-label="Next page"
            disabled={!hasNext}
          >
            <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="19"><path d="m8.889 8.527-5.171 8.528A15.567 15.567 0 0 1 0 15.333l4.128-6.806L0 1.722A15.735 15.735 0 0 1 3.718 0l5.17 8.527Z"></path></svg></span>
          </button>
        </li>
              )}
      </ul>
    </nav>
  )
}
